// extracted by mini-css-extract-plugin
export var container = "Paragraph-module--container--1aexv";
export var sideBySide = "Paragraph-module--sideBySide--1SlyB";